'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkCheckedList.module.css';

export function DevlinkCheckedList({ as: _Component = _Builtin.Block, showTitle = true, title = 'Heading', checkedList }) {
  return (
    <_Component tag="div">
      {showTitle ? (
        <_Builtin.Block tag="div">
          <_Builtin.Heading className={_utils.cx(_styles, 'txt-subheader')} tag="h5">
            {title}
          </_Builtin.Heading>
          <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
        </_Builtin.Block>
      ) : null}
      <_Builtin.Block className={_utils.cx(_styles, 'ht-checked-list')} tag="div">
        {checkedList}
      </_Builtin.Block>
    </_Component>
  );
}
